import { TFunction } from 'i18next';

export const dayTranslation = (day: string, t: TFunction) => {
  return t(`Calendar.${day.charAt(0).toUpperCase() + day.toLowerCase().slice(1)}`);
};
